// extracted by mini-css-extract-plugin
module.exports = {"cover_image":"CoverImage-module--cover_image--1vPRd","cover_image__image":"CoverImage-module--cover_image__image--145qn"};